// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import GuestListController from "./guest_list_controller"
application.register("guest-list", GuestListController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PushController from "./push_controller"
application.register("push", PushController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import PolicyToggleController from "./policy_toggle_controller"
application.register("policy-toggle", PolicyToggleController)

import RsvpFormController from "./rsvp_form_controller"
application.register("rsvp-form", RsvpFormController)
